<div class="p-3 pt-2 rounded-4">
    <div>
        <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between align-items-center">
            <div class="p-3 d-flex align-items-center gap-2">
                <button class="btn btn-sm btn-light rounded-pill" (click)="goBack()">
                    <i class="bi bi-arrow-left"></i> Back
                </button>
                <span>Beneficiary Transactions</span>
            </div>
        </div>
    </div>
    <div class="container-fluid mb-3 date-filter-wrapper mt-3">
        <app-date-filter [fromDate]="selectedFromDate" [toDate]="selectedToDate" 
            (dateSelected)="onDateSelected($event)"></app-date-filter>
    </div>
    <div class="container-fluid">
        <div class="row bg-white p-2 pt-0">
            <div class="col-md-12 mt-4 mb-5">
                <div class="table-responsive">
                    <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>
